import { render, staticRenderFns } from "./PTC.vue?vue&type=template&id=26e9aa96&scoped=true&"
import script from "./PTC.vue?vue&type=script&lang=js&"
export * from "./PTC.vue?vue&type=script&lang=js&"
import style0 from "./PTC.vue?vue&type=style&index=0&id=26e9aa96&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26e9aa96",
  null
  
)

export default component.exports